// UserRolesView.jsx
import { Box, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import IntegrationImage from "../../../../integrations/components/IntegrationImage";
import TextIntegrationStyle from "../../TextIntegrationStyle";
import { getUserRolesRows } from "../user/checkRowsUserData";
import useUserById from "./checkNonHumanIdentityData";
import { getNHIRolesRows } from "./checkRowsNonHumanIdentityData";

const NonHumanIdentityRolesView = ({ entityData }) => {
  const [rows, setRows] = useState([]);
  const user = useUserById(entityData);

  useEffect(() => {
    if (user) {
      setRows(getUserRolesRows(user));
    } else {
      setRows(getNHIRolesRows(entityData));
    }
  }, [user, entityData]);

  return rows ? (
    <Box display={"flex"} flexDirection={"column"} gap={2}>
      <Box display={"flex"} flexDirection={"column"} gap={1}>
        <Box display={"flex"} gap={1} alignItems={"center"}>
          <Typography variant="subtitle2">Roles</Typography>
        </Box>
        <Box display={"flex"} flexDirection={"column"} ml={3} gap={1}>
          {rows.map((row) => (
            <TextIntegrationStyle
              key={row.id}
              title={
                <Box display={"flex"} gap={1}>
                  <IntegrationImage
                    name={row.source}
                    width={"16px"}
                    newLogo={true}
                  />
                </Box>
              }
              value={row.role_name}
            />
          ))}
        </Box>
      </Box>
    </Box>
  ) : null;
};

export default NonHumanIdentityRolesView;
